import { gql } from '@apollo/client';

const COUNTRIES_QUERY = gql`
    query countries {
        countries {
            edges {
                node {
                    id
                    name
                    code
                }
            }
            pageInfo {
                page
                limit
                orderBy
                orderDir
                pageCount
                totalCount
                totalPages
            }
        }
    }
`;

export default COUNTRIES_QUERY;
